// src/components/admin/admintopbar/TopBar.jsx

import { Bell, Menu } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import "../../../assets/css/admin/adminTopbar/AdminTopBar.css";
import AppContext from "../../../context/AppContext";

// Turns a full name into initials,
const getInitials = (name) => {
  if (!name) return "A";

  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
};

const Topbar = ({ onMenuToggle }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const {
    loggedInAdmin,
    authToken,
    adminNotificationCount,
    fetchAdminNotificationCount,
  } = useContext(AppContext);

  useEffect(() => {
    if (loggedInAdmin && authToken) {
      fetchAdminNotificationCount();
    }
  }, [authToken, loggedInAdmin]);

  return (
    <div className="topbar">
      <button
        className="topbar-hamburger"
        onClick={onMenuToggle}
        aria-label="Toggle sidebar"
      >
        <Menu size={20} />
      </button>

      <h1 className="welcome-text">WELCOME!</h1>

      <div className="topbar-right">
        <a href="/admin/notifications" className="icon-btn notification-btn">
          <Bell size={20} />
          {adminNotificationCount > 0 && (
            <span className="admin-topbar-notification-badge">
              {adminNotificationCount}
            </span>
          )}
        </a>
        <div className="admin-profile">
          <div className="admin-avatar admin-avatar--initials">
            {getInitials(loggedInAdmin?.name)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
